var map = {
	"./pattern-1.png": [
		12053,
		7471
	],
	"./pattern-10.png": [
		12054,
		7472
	],
	"./pattern-11.png": [
		12055,
		7473
	],
	"./pattern-12.png": [
		12056,
		7474
	],
	"./pattern-13.png": [
		12057,
		7475
	],
	"./pattern-14.png": [
		12058,
		7476
	],
	"./pattern-15.png": [
		12059,
		7477
	],
	"./pattern-16.png": [
		12060,
		7478
	],
	"./pattern-17.png": [
		12061,
		7479
	],
	"./pattern-18.png": [
		12062,
		7480
	],
	"./pattern-19.png": [
		12063,
		7481
	],
	"./pattern-2.png": [
		12064,
		7482
	],
	"./pattern-20.png": [
		12065,
		7483
	],
	"./pattern-21.png": [
		12066,
		7484
	],
	"./pattern-22.png": [
		12067,
		7485
	],
	"./pattern-23.png": [
		12068,
		7486
	],
	"./pattern-24.png": [
		12069,
		7487
	],
	"./pattern-25.png": [
		12070,
		7488
	],
	"./pattern-3.png": [
		12071,
		7489
	],
	"./pattern-4.png": [
		12072,
		7490
	],
	"./pattern-5.png": [
		12073,
		7491
	],
	"./pattern-6.png": [
		12074,
		7492
	],
	"./pattern-7.png": [
		12075,
		7493
	],
	"./pattern-8.png": [
		12076,
		7494
	],
	"./pattern-9.png": [
		12077,
		7495
	],
	"./pattern-paper-transparent.png": [
		12078,
		7496
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 7426;
module.exports = webpackAsyncContext;